import { defineMessages } from 'react-intl';

export default defineMessages({
  deviceStatusDeactivated: {
    defaultMessage: 'Deactivated',
    description: '',
    id: 'deviceStatus.deactivated',
  },
});
